import {EntityModel} from "@fedeltapointofsale/data-client";
import {ContactData} from "./contact.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class ContactEntityModel extends EntityModel<ContactData> {

    constructor(injector: Injector) {
        super(injector, ContactData);
    }

    override isEntityCloneable(): boolean {
        return false;
    }

    override async canUpdateEntity(): Promise<boolean> {
        return this.data.integratedLoyaltyId == undefined;
    }
}
